import { createContext, useState } from "react";
import { clearLocal, getLocalUser } from "../utils/helper";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(getLocalUser());

  if (!auth) {
    clearLocal();
  }

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
